<template>
  <bita-modal
    :id="modalId"
    :title="title"
    :modal-lg="true"
    :isLoading="isLoading"
    @close="onCloseModal"
  >
    <div slot="body">
      <bita-ibox :is-loading="isLoadingModal">
        <div slot="body">
          <div v-if="!dataForm.is_broker" class="alert alert-warning">
            <h5>
              صاحب بار انتخاب شده بروکر نمی باشد.ابتدا نیاز است تا دسترسی بروکر
              به صاحب بار داده شود.
            </h5>
          </div>
          <div class="row" v-if="dataForm.is_broker && showGrid">
            <bita-multiselect
              name="owners"
              label="انتخاب صاحب بار"
              ref="ownersMultiSelect"
              validation-container-class="col-12"
              input-class="form-control"
              :data-source="propsOwner"
              data-text-field="name"
              data-value-field="id"
              v-model="owners"
            />
            <div class="col-lg-3 mb-1">
              <bita-bootbutton
                type="primary"
                title="بروزرسانی"
                icon="fa fa-check"
                btn-width="150px"
                @click.native="brokerOwnersUpdate()"
              />
            </div>
          </div>
          <bita-ibox :is-loading="isLoadingGrid">
            <div slot="body">
              <bita-grid
                v-if="dataForm.is_broker && showGrid"
                ref="ownerGrid"
                name="ownerGrid"
                :columns="gridColumns"
                :read-data="readData"
                :hasRow="false"
              />
            </div>
          </bita-ibox>
        </div>
      </bita-ibox>
    </div>
    <div slot="footer"></div>
  </bita-modal>
</template>
<script>
export default {
  props: {
    modalId: String,
    title: String,
    isLoading: Boolean,
    propsData: Object,
    propsOwner: Array,
  },
  data() {
    return {
      owners: [],
      dataForm: {},
      isLoadingModal: false,
      isLoadingGrid: false,
      showGrid: false,
      gridColumns: [
        { title: "#", template: this.$getTemplate, width: "40px" },
        { field: "name", title: "نام" },
        {
          field: "loading_fee",
          title: "هزینه بارگیری",
        },
        {
          field: "created_at",
          title: "تاریخ ایجاد",
          template: (e) =>
            e.created_at ? this.$getJalaliDateTime(e.created_at) : "",
        },
        {
          title: "عملیات",
          command: [],
        },
      ],
    };
  },
  mounted() {
    this.gridColumns[this.gridColumns.length - 1].command = this.gridCommands();
  },
  methods: {
    setData(_formData) {
      this.showGrid = true;
      this.dataForm = _formData;
    },
    readData(e) {
      this.isLoadingGrid = true;
      this.$persistClient("get", `brokers/${this.dataForm.id}/owners`)
        .then((res) => {
          e.success(res.data);
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },
    loadData() {
      this.$refs.ownerGrid.loadDataSource();
    },
    gridCommands() {
      let commands = [];
      commands.push({
        text: "delete",
        click: this.delete,
        template: this.gridButtons.delete,
      });
      return commands;
    },
    delete(e) {
      let owner = this.$refs.ownerGrid.getSelectedGridRow(e);
      this.$alert("question", `آیا از حذف  ${owner.name} اطمینان دارید ؟`, "", {
        confirmButtonText: "بله",
      }).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          this.$persistClient(
            "delete",
            `brokers/${this.dataForm.id}/owners/${owner.id}`
          )
            .then((res) => {
              this.$izitoast("success", "عملیات موفق", res.data.message);
              this.loadData();
            })
            .finally(() => {
              this.isLoadingGrid = false;
            });
        }
      });
    },
    onCloseModal() {
      this.showGrid = false;
      this.owners = [];
    },
    brokerOwnersUpdate() {
      this.isLoadingModal = true;
      let data = {
        owner_id: this.owners,
      };
      this.$persistClient("patch", `brokers/${this.dataForm.id}/owners`, data)
        .then((res) => {
          this.$izitoast("success", "عملیات موفق", res.data.message);
          this.loadData();
        })
        .finally(() => (this.isLoadingModal = false));
    },
  },
};
</script>
